import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// The redux slice to store login token info. this can be used for future use cases as well.

export interface ILoginTokenInfoState {
    _accessToken?: string
    _refreshToken?: string
    _idToken?: string
    _tokenType?: string
    _tokenExpiry?: number
    _isLoggedIn?: boolean
    _refreshTokenCallbackTime?: number
}

const initialState: ILoginTokenInfoState = {
    _accessToken: null,
    _refreshToken: null,
    _idToken: null,
    _tokenType: null,
    _tokenExpiry: null,
    _isLoggedIn: false,
    _refreshTokenCallbackTime: null,
}

export const loginTokenInfoSlice = createSlice({
    name: 'loginTokenInfoSlice',
    initialState,
    reducers: {
        setTokenInfo: (state, action: PayloadAction<ILoginTokenInfoState>) => {
            state._accessToken = action.payload._accessToken
            state._refreshToken = action.payload._refreshToken
            state._idToken = action.payload._idToken
            state._tokenType = action.payload._tokenType
            state._tokenExpiry = action.payload._tokenExpiry
            state._refreshTokenCallbackTime = action.payload._refreshTokenCallbackTime
        },
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state._isLoggedIn = action.payload
        },
    },
})

export const {
    setTokenInfo,
    setIsLoggedIn,
} = loginTokenInfoSlice.actions

export default loginTokenInfoSlice.reducer
